import {
  EDIT_QUIZZ_ANSWER,
  EDIT_QUIZZ_ANSWER_SUCCESS,
  EDIT_QUIZZ_ANSWER_CLEAN,
  EDIT_QUIZZ_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  answer: undefined,
}

const QuizzAnswerEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_QUIZZ_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_QUIZZ_ANSWER_SUCCESS:
      state = {
        ...state,
        answer: action.payload.answer,
        loading: false,
        done: true,
      }
      break
    case EDIT_QUIZZ_ANSWER_CLEAN:
      state = initialState
      break
    case EDIT_QUIZZ_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuizzAnswerEdit
